import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import CONSTANTS from '../../_constants/constants';

import { SharedModule } from '../../_shared/shared.module';
import { AbilityService } from '../../_shared/services/ability.service';
import { DataService } from '../../_shared/services/data.service';
import { SessionService } from '../../_shared/services/session.service';
import { UtilService } from '../../_shared/services/util.service';

import { PickupPlace } from '../shared/pickup-place.model';
import { PickupPlaceService } from '../shared/pickup-place.service';

@Component({
  selector: 'app-pickup-place-list',
  templateUrl: './pickup-place-list.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class PickupPlaceListComponent {
  @Input() pickupPlaces: PickupPlace[];
  @Input() meta;
  @Input() loadingPickupPlaces: boolean;
  @Input() defaultLanguage;

  @Output() private selectedPickupPlace = new EventEmitter<{
    pickupPlace: PickupPlace;
    mode: string;
  }>();

  permissions = {
    canShow: this.abilityService.can('show_pickupplace_accountadmin'),
    canUpdate: this.abilityService.can('update_pickupplace_accountadmin'),
    canDestroy: this.abilityService.can('destroy_pickupplace_accountadmin'),
  };

  filterCriteria = this.pickupPlaceService.getFilterCriteria();

  pickupPlaceOptions = CONSTANTS.PICKUP_PLACES_OPTIONS;

  form: FormGroup;

  constructor(
    private pickupPlaceService: PickupPlaceService,
    private abilityService: AbilityService,
    private dataService: DataService,
    private sessionService: SessionService,
    public utilService: UtilService,
    private formBuilder: FormBuilder
  ) {
    this.form = this.formBuilder.group({
      by_type: '',
    });
  }

  reloadPickupPlaces() {
    this.filterCriteria = this.pickupPlaceService.getFilterCriteria();

    this.setDefaultFilters();

    this.getPickupPlaces();
  }

  // Referenced from app-search-text-input
  onSearched({ field, value }) {
    this.filterPickupPlaces(field, value);
  }

  filterPickupPlaces(field, value) {
    this.filterCriteria = this.utilService.setFilterCriteria(this.filterCriteria, field, value);

    this.getPickupPlaces();
  }

  clearSearchForm() {
    this.reloadPickupPlaces();
  }

  // Referenced from app-sort-by
  onSorted({ sortBy, sortDir }) {
    this.filterCriteria.page = 1;
    this.filterCriteria.sortDir = sortDir;
    this.filterCriteria.sortedBy = sortBy;

    this.getPickupPlaces();
  }

  // Referenced from app-table-footer
  onSelectedPage({ page, offset }) {
    this.filterCriteria.page = page;
    this.filterCriteria.offset = offset;

    this.getPickupPlaces();
  }

  selectPickupPlace(pickupPlace: PickupPlace, mode = '') {
    if (!this.permissions.canShow) return;

    this.selectedPickupPlace.emit({ pickupPlace, mode });
  }

  /*
  // Referenced from app-list-actions
  onUpdatedItems(option) {
    let successCallback = () => {
      this.getPickupPlaces();
    };

    this.dataService.changeItemsStatus('pickup_places', this.pickupPlaces, option, successCallback);
  }

  // Referenced from app-list-actions
  onDeletedItems() {
    let successCallback = () => {
      this.getPickupPlaces();
    };

    this.dataService.deleteItems('pickup_places', this.pickupPlaces, successCallback);
  }
  */

  changePickupPlaceStatus(pickupPlace: PickupPlace) {
    let successCallback = () => {
      this.utilService.changeItemRowStyle(pickupPlace.id);
    };

    // const params = {
    //   title: 'Deactivate pickupPlace',
    //   message: 'Do you want to deactivate this pickupPlace?',
    //   successMsg: 'PickupPlace updated',
    // };

    this.dataService.changeItemStatus('pickup_places', pickupPlace, successCallback); // params
  }

  deletePickupPlace(pickupPlace: PickupPlace) {
    let successCallback = () => {
      this.getPickupPlaces();
    };

    const params = {
      title: 'DELETE_PICKUP_PLACE',
      message: 'SURE_TO_DELETE_PICKUP_PLACE',
      reason: 'DELETE_ITEM_REASON',
      requireConfirmation: true,
      successMsg: 'PICKUP_PLACE_DELETED',
    };

    this.dataService.deleteItem('pickup_places', pickupPlace, successCallback, params);
  }

  private getPickupPlaces() {
    this.filterCriteria.lang = this.sessionService.getUserLanguage().code;

    this.loadingPickupPlaces = true;
    this.pickupPlaceService.getPickupPlaces(this.filterCriteria).subscribe((response) => {
      this.pickupPlaces = response.data;
      this.meta = response.meta;

      this.loadingPickupPlaces = false;
    });
  }

  private setDefaultFilters() {
    this.form.controls['by_type'].setValue('');
  }
}
